import { useEffect, useState } from "react";
import Tilt from "react-parallax-tilt";

/* A tilt that follows the pointer only makes sense when there is a pointer to
   follow: on touch screens it fires off taps and scrolls as jitter, and for
   anyone who asked for reduced motion it is exactly the kind of movement they
   opted out of. In both cases we render a plain wrapper and the card keeps its
   CSS lift. */
const NO_TILT_QUERY =
  "(prefers-reduced-motion: reduce), (hover: none), (pointer: coarse)";

export const Tilt3D = ({ children, className = "", ...tiltProps }) => {
  // Starts off so the first paint is the safe, untilted version; the effect
  // turns it on once we can actually read the media query.
  const [tiltEnabled, setTiltEnabled] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(NO_TILT_QUERY);
    const sync = () => setTiltEnabled(!mediaQuery.matches);

    sync();
    mediaQuery.addEventListener("change", sync);
    return () => mediaQuery.removeEventListener("change", sync);
  }, []);

  if (!tiltEnabled) {
    return <div className={className}>{children}</div>;
  }

  return (
    <Tilt
      className={className}
      tiltMaxAngleX={7}
      tiltMaxAngleY={7}
      perspective={1100}
      scale={1.02}
      transitionSpeed={1200}
      glareEnable
      glareMaxOpacity={0.16}
      glareColor="#ffffff"
      glarePosition="all"
      {...tiltProps}
    >
      {children}
    </Tilt>
  );
};
